if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const source = data?.html?.querySelector('[data-hero-button-price]');
    const target = document.querySelector(
      `#ProductSubmitButton-${data?.sectionId} [data-hero-button-price]`
    );
    if (source && target) target.textContent = source.textContent;
  });
}

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.querySelector('[data-hero-nav="prev"]')?.addEventListener('click', () => this.shift(-1));
        this.querySelector('[data-hero-nav="next"]')?.addEventListener('click', () => this.shift(1));

        this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((thumb) => {
          thumb.querySelector('button')?.addEventListener('click', (event) => {
            event.preventDefault();
            this.setActiveMedia(thumb.dataset.target, false);
          });
        });

        this.updateCounter();
      }

      slides() {
        if (!this.elements.viewer) return [];
        return Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
      }

      shift(delta) {
        const slides = this.slides();
        if (slides.length < 2) return;
        const current = Math.max(
          0,
          slides.findIndex((slide) => slide.classList.contains('is-active'))
        );
        const next = slides[(current + delta + slides.length) % slides.length];
        this.setActiveMedia(next.dataset.mediaId, false);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstElementChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }
          const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          this.elements.thumbnails?.resetPages?.();
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);

        const activeThumbnail =
          this.elements.thumbnails?.querySelector(`[data-target="${activeMedia.dataset.mediaId}"]`) || null;
        this.setActiveThumbnail(activeThumbnail);
        this.updateCounter();
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails) return;
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((element) => {
          element.classList.remove('is-on');
          element.querySelector('button')?.removeAttribute('aria-current');
        });
        if (!thumbnail) return;
        thumbnail.classList.add('is-on');
        thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');
        this.scrollThumbnailIntoView(thumbnail);
      }

      scrollThumbnailIntoView(thumbnail) {
        const scroller = this.elements.thumbnails;
        if (!scroller || typeof scroller.isSlideVisible !== 'function') return;
        if (scroller.isSlideVisible(thumbnail, 8)) return;
        scroller.setSlidePosition(thumbnail.offsetLeft);
      }

      updateCounter() {
        const slides = this.slides();
        if (!slides.length) return;
        const index = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const current = this.querySelector('[data-hero-counter="current"]');
        const total = this.querySelector('[data-hero-counter="total"]');
        if (current) current.textContent = String(index < 0 ? 1 : index + 1);
        if (total) total.textContent = String(slides.length);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image || !this.elements.liveRegion || !window.accessibilityStrings?.imageAvailable) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    }
  );
}
